import { render, staticRenderFns } from "./LabelToolEmbed.vue?vue&type=template&id=424da972&scoped=true"
import script from "./LabelToolEmbed.vue?vue&type=script&lang=js"
export * from "./LabelToolEmbed.vue?vue&type=script&lang=js"
import style0 from "./LabelToolEmbed.vue?vue&type=style&index=0&id=424da972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424da972",
  null
  
)

export default component.exports